import { faInstagram, faFacebookF, faYoutube, faTwitter } from "@fortawesome/free-brands-svg-icons";

const FabIcons = [faInstagram, faFacebookF, faYoutube, faTwitter];

export default FabIcons;
